import { jsx as _jsx } from "react/jsx-runtime";
import s from './spinner.module.scss';
export const Spinner = ({ size = 'medium', color = '#000000', className }) => {
    const spinnerClassName = `${s.spinner} ${s[size]}`;
    return (_jsx("div", { className: `${spinnerClassName} ${className || ''}`, style: { borderTopColor: color } }));
};
